import React from "react";
import {
  Box,
  Chip,
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  DragIndicator as DragIcon,
} from "@mui/icons-material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableQuestionRow({
  question,
  onEdit,
  onDelete,
  prizes,
  topics = [],
  difficulties = [],
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: question.id });
  const style = { transform: CSS.Transform.toString(transform), transition };
  const prize = prizes.find((p) => p.level === question.level);
  const topicLabel = question.topic_id
    ? topics.find((t) => t.id === question.topic_id)?.display_name ||
      topics.find((t) => t.id === question.topic_id)?.topic_name ||
      question.topic
    : question.topic;
  const difficultyLabel = question.difficulty_id
    ? difficulties.find((d) => d.id === question.difficulty_id)?.level_name ||
      question.difficulty
    : question.difficulty;
  return (
    <ListItem
      ref={setNodeRef}
      style={style}
      sx={{
        bgcolor: "#1e1e1e",
        mb: 0.5,
        borderRadius: 1,
        border: "1px solid #333",
      }}>
      <Box
        {...attributes}
        {...listeners}
        sx={{
          mr: 1,
          cursor: "grab",
          color: "#888",
          display: "flex",
          alignItems: "center",
        }}>
        <DragIcon />
      </Box>
      <Chip
        label={`L${question.level}`}
        size="small"
        sx={{ mr: 1, bgcolor: "#4a6741", color: "#fff", fontWeight: 700 }}
      />
      {prize?.is_checkpoint ? (
        <Chip
          label="CP"
          size="small"
          sx={{ mr: 1, bgcolor: "#b8860b", color: "#fff" }}
        />
      ) : null}
      {(topicLabel || question.topic) && (
        <Chip
          label={topicLabel || question.topic}
          size="small"
          sx={{ mr: 1, bgcolor: "#1565c0", color: "#fff" }}
        />
      )}
      {(difficultyLabel || question.difficulty) && (
        <Chip
          label={difficultyLabel || question.difficulty}
          size="small"
          sx={{
            mr: 1,
            bgcolor:
              difficultyLabel === "Hard" || question.difficulty === "hard"
                ? "#c62828"
                : difficultyLabel === "Medium" ||
                    question.difficulty === "medium"
                  ? "#e65100"
                  : "#2e7d32",
            color: "#fff",
          }}
        />
      )}
      <ListItemText
        primary={
          <Typography
            noWrap
            sx={{ maxWidth: 400, color: "#fff" }}>
            {question.question_text}
          </Typography>
        }
        secondary={
          <Typography
            variant="caption"
            sx={{ color: "#aaa" }}>
            Answer: {question.correct_answer}
          </Typography>
        }
      />
      <ListItemSecondaryAction>
        <IconButton
          size="small"
          onClick={() => onEdit(question)}
          sx={{ color: "#90caf9" }}>
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => onDelete(question.id)}
          sx={{ color: "#ef5350" }}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default SortableQuestionRow;
